<template>
  <div class="p-3 pl-5">
    <div class="vertical-line">
      <div class="circle">
        <div class="dot"></div>
      </div>
      <div class="pl-3 content-log text-black">
        <strong>Mochammad Zuhrianto</strong>
        <div class="d-flex align-items-center mb-1 text-blue-400">
          <i class="fa fa-calendar mr-2"></i>
          <p class="text-sm mb-0">11 Feb 2024 14:00</p>
        </div>
        <p class="text-sm">Service Repair Has Been Approved</p>
        <p class="text-sm mb-0">Comment:</p>
        <small>Data sudah saya approve dan lanjutkan untuk proses repair</small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logs: [],
    }
  },
}
</script>
<style scoped>
.vertical-line {
  border-left: 2.4px solid #e5e7eb;
  min-height: 100px;
  position: relative;
}
.circle {
  width: max-content;
  border: 1.5px solid #1f48aa;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  padding: 4px;
  position: absolute;
  left: -10px;
  top: -6px;
}
.dot {
  width: 8px;
  height: 8px;
  background: #1f48aa;
  border-radius: 50%;
}
.text-blue-400 {
  color: #334697;
}
.text-sm{
  font-size: small;
}
</style>
